export default "__VITE_ASSET__BNWsde_m__"